import "./App.scss";
import GalenaSession from "./components/galena-session/GalenaSession";

const APP_VERSION = "0.4.3";

function App() {
  return (
    <div className="App">
      <GalenaSession />
      <footer className="app-version">v{APP_VERSION}</footer>
    </div>
  );
}

export default App;
